import { computed, Injectable, signal } from '@angular/core';

import { resolveCostaClickCultureCode } from '../functions/costa-click-culture.functions';
import type { AgencyInfo } from '../types/agency.interfaces';
import { normalizeAgencyMarket } from '../types/agency-market.types';

@Injectable({
  providedIn: 'root',
})
export class AgencyService {
  private readonly agencyInfoState = signal<AgencyInfo | undefined>(undefined);

  public readonly agencyInfo = this.agencyInfoState.asReadonly();
  public readonly agencyCode = computed(() => {
    const agencyCode = this.agencyInfo()?.AgencyId?.trim();
    return agencyCode || undefined;
  });
  public readonly market = computed(() => normalizeAgencyMarket(this.agencyInfo()?.Market));
  public readonly costaClickCulture = computed(() => {
    const agencyInfo = this.agencyInfo();
    return resolveCostaClickCultureCode(this.market(), agencyInfo?.Language, agencyInfo?.Culture);
  });

  public setAgencyInfo(agencyInfo: AgencyInfo): void {
    this.agencyInfoState.set(agencyInfo);
  }

  public clearAgencyInfo(): void {
    this.agencyInfoState.set(undefined);
  }
}
